<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
   [spinner]="spinkit.skThreeBounce">
</ng-http-loader>
<mat-tab-group *ngIf="viewOrder==false">
   <mat-tab label="Live orders ">
      <div class="container py-4">
         <div *ngIf="getTableDetails.length !=0">
            <tc-card class="mb-0">
               <tc-table [rows]="getTableDetails" [search]="true" [hovered]="true" [pagination]="true"
                  [headerBgColor]="'#fb8033'" [headerColor]="'#ffffff'" [headerBgColor]="'#3e51b5'">
                  <!-- <tc-table-col [columnTitle]="'S.No.'" [columnName]="'serial'">
                  <ng-template #tableTDTemplate let-value>
                     <span>{{value}}</span>
                  </ng-template>
                  </tc-table-col> -->
                  <tc-table-col [columnTitle]="'Table name'" [columnName]="'restaurant_table_name'">
                     <ng-template #tableTDTemplate let-value>
                        <strong>{{ value }}</strong>
                     </ng-template>
                  </tc-table-col>
                  <tc-table-col [columnTitle]="'Order status'" [columnName]="'restaurant_table_status'">
                     <ng-template #tableTDTemplate let-value>
                        <div *ngIf="value === 'Pending'">
                           <tc-badge [tcShape]="0" [view]="'warning'">Pending</tc-badge>
                        </div>
                        <div *ngIf="value === 'Verified'">
                           <tc-badge [tcShape]="0" [view]="'info'">Verified</tc-badge>
                        </div>
                        <div *ngIf="value === 'Cooking'">
                           <tc-badge [tcShape]="0" [view]="'accent'">Cooking</tc-badge>
                        </div>
                        <div *ngIf="value === 'Accepted'">
                           <tc-badge [tcShape]="0" [view]="'success'">Accepted</tc-badge>
                        </div>
                        <div *ngIf="value === 'Ready'">
                           <tc-badge [tcShape]="0" [tcBgColor]="'#00bcd4'">Ready</tc-badge>
                        </div>
                     </ng-template>
                  </tc-table-col>
                  <tc-table-col [columnTitle]="'Order details'" [columnName]="''">
                     <ng-template #tableTDTemplate let-value="row">
                        <button tc-button [tcShape]="500" [size]="'sm'" [tcBgColor]="'#fb8033'"
                           (click)="orderDetails(value.restaurant_table_id)">Order details</button>
                     </ng-template>
                  </tc-table-col>
                  <tc-table-col [columnTitle]="'Created on'" [columnName]="'restaurant_table_created_on'">
                     <ng-template #tableTDTemplate let-value>
                        <strong>{{ value }}</strong>
                     </ng-template>
                  </tc-table-col>
                  <tc-table-col [columnTitle]="'Updated on'" [columnName]="'restaurant_table_updated_on'">
                     <ng-template #tableTDTemplate let-value>
                        <strong>{{ value }}</strong>
                     </ng-template>
                  </tc-table-col>
                  <tc-table-col [columnTitle]="'Action'" [columnName]="">
                     <ng-template #tableTDTemplate let-value="row">
                        <button tc-button [tcShape]="500" [size]="'sm'" [tcBgColor]="'#fb8033'"
                           (click)="openModal(modalBody,value.restaurant_table_id,value.restaurant_table_name,value.restaurant_table_status)">Update
                           status</button>
                     </ng-template>
                  </tc-table-col>
               </tc-table>
            </tc-card>
            <div class="row py-4">
               <tc-badge [tcShape]="0" [view]="'warning'">Pending</tc-badge>&nbsp;&nbsp;
               <tc-badge [tcShape]="0" [view]="'info'">Verified</tc-badge>&nbsp;&nbsp;
               <tc-badge [tcShape]="0" [view]="'success'">Accepted</tc-badge>&nbsp;&nbsp;
               <tc-badge [tcShape]="0" [view]="'accent'">Cooking</tc-badge>&nbsp;&nbsp;
               <tc-badge [tcShape]="0" [tcBgColor]="'#00bcd4'">Ready</tc-badge>&nbsp;&nbsp;
            </div>
         </div>


         <!-- openModal for update status start -->
         <ng-container>
            <ng-template #modalBody>
               <h2 style="color: #479943 !important;" class="title text-center">Update order status</h2>
               <h4 style="color:#f07408!important; font-weight: 600;" class="text-center">Table name: #{{TableName}}</h4>
               <tc-select style="margin-top: 30px;" [placeholder]="'Update status'" [options]="data" [(ngModel)]="selectStatus"
                  [selected]="selectStatus" [allowClear]="true">{{selectStatus}}</tc-select>
               <div style="margin-top :135px" class="actions text-center">
                  <button tc-button [tcBgColor]="'#fb8033'" [disabled]="!selectStatus"
                     (click)="UpdateDineinLiveOrder(selectStatus)">Submit</button> &nbsp;
                                                                                                                                                                                                                                    <button tc-button [type]="'button'" [view]="'error'" (click)="closeModal()"> Close</button>
               </div>
               <br>
               <br>
            </ng-template>
         </ng-container>

         <!-- openModal for update status end -->

         <!-- image for no Live Orders -->
         <div *ngIf="getTableDetails.length === 0">
            <div class="col-12" align="center">
               <img src="./assets/img/NDOF.png" alt="" width="23%">
            </div>
         </div>

      </div>

   </mat-tab>
   <mat-tab label="Completed orders">

      <div class="container py-4">
         <div *ngIf="getTableDetailsCompleted.length != 0">
            <tc-card class="mb-0">
               <tc-table [rows]="getTableDetailsCompleted" [search]="true" [hovered]="true" [pagination]="true"
                  [headerBgColor]="'#fb8033'" [headerColor]="'#ffffff'" [headerBgColor]="'#3e51b5'">
                  <tc-table-col [columnTitle]="'Table name'" [columnName]="'restaurant_table_name'">
                     <ng-template #tableTDTemplate let-value>
                        <strong>{{ value }}</strong>
                     </ng-template>
                  </tc-table-col>
                  <tc-table-col [columnTitle]="'Order status'" [columnName]="'restaurant_table_status'">
                     <ng-template #tableTDTemplate let-value>
                        <tc-badge [tcShape]="0" [view]="value === 'Completed' ? 'success' : 'error'">{{ value }}
                        </tc-badge>
                     </ng-template>
                  </tc-table-col>
                  <tc-table-col [columnTitle]="'Order details'" [columnName]="''">
                     <ng-template #tableTDTemplate let-value="row">
                        <button tc-button [tcShape]="500" [size]="'sm'" [tcBgColor]="'#fb8033'"
                           (click)="completedOrderDetails(value.restaurant_table_id)">Order details</button>
                     </ng-template>
                  </tc-table-col>
                  <tc-table-col [columnTitle]="'Created on'" [columnName]="'restaurant_table_created_on'">
                     <ng-template #tableTDTemplate let-value>
                        <strong>{{ value }}</strong>
                     </ng-template>
                  </tc-table-col>
                  <tc-table-col [columnTitle]="'Updated on'" [columnName]="'restaurant_table_updated_on'">
                     <ng-template #tableTDTemplate let-value>
                        <strong>{{ value }}</strong>
                     </ng-template>
                  </tc-table-col>
               </tc-table>
            </tc-card>
            <div class="row py-4">
               <tc-badge [tcShape]="0" [view]="'success'">Completed</tc-badge>&nbsp;&nbsp;
               <tc-badge [tcShape]="0" [view]="'error'">Cancelled</tc-badge>&nbsp;&nbsp;
            </div>
         </div>
      </div>
      <div class="py-4" *ngIf="getTableDetailsCompleted.length === 0">
         <div class="col-12" align="center">
            <img src="./assets/img/NLZDOF.png" alt="" width="23%">
         </div>
      </div>
   </mat-tab>
</mat-tab-group>
<div *ngIf="viewOrder==true">
   <br>
   <tc-form-group class="table-row btn">
      <span class="valuegross"  *ngFor="let item of viewOrderLive | filter:searchText;let i=index">
         Gross total : £ {{item.gross_amount}}
      </span> &nbsp;
      <button  class="button1" (click)="backToLiveOrders()" >
         <tc-icon [iconClass]="'icofont-ui-home'"[tcFontSize]="22" 
        [tcColor]="['#fffff', '#fffff']"  title="Back to Home" style="margin-top: -7px !important;"></tc-icon>
        Back To Home
     </button>

   </tc-form-group>
   <div class="container">
      <div class="form-group">
         <tc-form-group>
           <tc-input [prefixIcon]="'icofont-search'" [placeholder]="'Search Dish'" [type]="'text'"
             [(ngModel)]="searchText"></tc-input>
         </tc-form-group>
       </div>

      <div class="main" *ngFor="let item of viewOrderLive | filter:searchText;let i=index ">
         <div *ngFor="let viewitems of item.orderDetail | filter:searchText;let i=index ">
            <div class="row">
               <div class="col-2">Order summary</div>
               <div class="col-4 " style="font-weight: bold;">Table no: {{viewitems.order_table_no}}</div>

            </div>
            <br>
            <div class="row">
               <div class="col-2">Customer</div>
               <div class="col-4">{{viewitems.userDetail.name}}</div>
               <div class="col-2">Mobile number</div>
               <div class="col-4">{{viewitems.userDetail.mobile}}</div>
            </div>
            <br>
            <div class="row ">
               <div class="col-2">Order no</div>
               <div class="col-4"> {{viewitems.order_no}}
                  <span *ngIf="viewitems.order_status == 'Pending'">
                     <tc-badge [tcShape]="0" [size]="'sm'" [view]="'warning'">Pending</tc-badge>
                   </span>
                   <span *ngIf="viewitems.order_status   == 'Verified'">
                     <tc-badge [tcShape]="0" [size]="'sm'" [view]="'info'">Verified</tc-badge>
                   </span>
                   <span *ngIf="viewitems.order_status   == 'Cooking'">
                     <tc-badge [tcShape]="0" [size]="'sm'" [view]="'accent'">Cooking</tc-badge>
                   </span>
                   <span *ngIf="viewitems.order_status   == 'Accepted'">
                     <tc-badge [tcShape]="0" [size]="'sm'" [view]="'success'">Accepted</tc-badge>
                   </span>
                   <span *ngIf="viewitems.order_status  == 'Ready'">
                     <tc-badge [tcShape]="0" [size]="'sm'" [tcBgColor]="'#00bcd4'">Ready</tc-badge>
                   </span>
                   <span *ngIf="viewitems.order_status   == 'Completed'">
                     <tc-badge [tcShape]="0" [size]="'sm'" [view]="'success'">Completed</tc-badge>
                   </span>
                   <span *ngIf="viewitems.order_status  == 'Cancelled'">
                    <tc-badge [tcShape]="0" [size]="'sm'" [view]="'error'">Cancelled</tc-badge>
                  </span>
               </div>
               <div class="col-2">Order as</div>
               <div class="col-4">{{viewitems.order_user_id?'User':'Guest'}}</div>
            </div>
            <br>
            <hr>
            <br>
            <p style="font-weight: bold;">Food Dishes Details</p>
            <div class="row" *ngFor="let dishes of viewitems.order_item | filter:searchText;let i=index ">
            
               <div class="col-4">
                  {{ dishes.food_dishes_name}}  x {{dishes.order_item_quantity}}
                  <div class="row" *ngFor="let value of dishes.order_item_options | filter:searchText;let i=index " >
                     <div class="col-4">
                        {{value.oio_option_name}}
                     </div>
                     <div class="col-4 textright"> £ {{value_amount(value.oio_option_price)}}</div>
                  </div>

                  <div class="row add_text" *ngFor="let value of dishes.order_item_add_on | filter:searchText;let i=index">
                     <div class="col-12">Add ons</div>
                  </div>

                  <div class="row" *ngFor="let value of dishes.order_item_add_on | filter:searchText;index as i">
                     <div class="col-4">
                        {{i+1}}. {{value.oia_add_name}}
                     </div>
                     <div class="col-4 textright"> £ {{value_amount(value.oia_addon_option_price)}}</div>
                  </div>

               
                  <div *ngIf="!dishes.order_item_spice ||  dishes.order_item_spice =='0'">No spice rating</div>
                  <div *ngIf="dishes.order_item_spice && dishes.order_item_spice !='0'">
                     <img *ngFor="let value of counter(dishes.order_item_spice);" src="./assets/img/mirchi.png"
                        alt="spice image" width="18" />
                  </div>
                  <br>
               </div>
               <div class="col-4 textright"> £ {{value_amount(dishes.order_item_price_with_quantity)}}</div>
            </div>
            <div class="row">
               <div class="col-4"> <strong>Total(Incl VAT)</strong> </div>
               <div class="col-4 textright"><strong>£ {{value_amount(viewitems.order_total_price)}}</strong> </div>
            </div>         
            <div class="row" *ngIf="viewitems.order_service_charge !=0">
               <div class="col-4"> <strong>Service Charge({{viewitems.order_service_charge_per}})</strong> </div>
               <div class="col-4 textright"><strong>£ {{value_amount(viewitems.order_service_charge)}}</strong> </div>
            </div>
            <div class="row " *ngIf="viewitems.order_coupan_value != 0">
               <div class="col-4"> <strong>Foodbud discount({{viewitems.order_coupan_per}})</strong> </div>
               <div class="col-4 textright"><strong> - £ {{value_amount(viewitems.order_coupan_value)}}</strong> </div>
            </div>
            <div class="row"  *ngIf="viewitems.order_coupan_value == 0 && viewitems.order_totalwithserviceprice == 0">
               <div class="col-4"> <strong>Amount Payable</strong> </div>
               <div class="col-4 textright"><strong>£ {{value_amount(viewitems.order_total_price)}}</strong> </div>
            </div>
            <div class="row"  *ngIf="viewitems.order_coupan_value == 0">
               <div class="col-4"> <strong>Amount Payable</strong> </div>
               <div class="col-4 textright"><strong>£ {{value_amount(viewitems.order_totalwithserviceprice)}}</strong> </div>
            </div>
            <div class="row"  *ngIf="viewitems.order_coupan_value != 0">
               <div class="col-4"> <strong>Amount Payable</strong> </div>
               <div class="col-4 textright"><strong>£ {{value_amount(viewitems.order_coupan_total_price)}}</strong> </div>
            </div>
            <br>
            <hr>
            <br>
            <div class="row">
               <div class="col-6 preferences">Allergens</div>
               <div *ngIf="viewitems.userDetail.overall_spice !='0'" class=" col-6 preferences">Spice tolerence</div>
            </div>
            <br>
            <div class="row">
               <div class="col-6">
                  <div *ngIf="!checkAllergences(viewitems.userDetail)">
                     {{viewitems.userDetail.allergens.allergens_name}}
                  </div>
                  <div *ngIf="checkAllergences(viewitems.userDetail)">
                     {{allergen_value(viewitems.userDetail.allergens)}}   
                  </div>
               </div>
               <div class="col-6 " *ngIf="viewitems.userDetail.overall_spice !='0'">
                  <img *ngFor="let value of counters(viewitems.userDetail.overall_spice);"
                     src="./assets/img/mirchi.png" alt="spice image" width="18" />
               </div>
            </div>
            <br>
            <div class="row">
               <div class="col-6 preferences">
                  Dietary preferences
               </div>
               <div class="col-6 preferences">
                  Avoid cross contamination
               </div>
            </div>
            <br>
            <div class="row">
               <div class="col-6">
                  <div *ngIf="!checkDietary(viewitems.userDetail)">
                     {{viewitems.userDetail.dietary.diet_preference_name}}
                  </div>
                  <div *ngIf="checkDietary(viewitems.userDetail)">
                        {{dietary_value(viewitems.userDetail.dietary)}}
                  </div>
               </div>
               <div class="col-6">
                  {{viewitems.userDetail.cc}}
               </div>
            </div>
            <hr class="new">
            <br>
         </div>
      </div>
   </div>
</div>